import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import Root from '../Root';
import { translationsReady } from '@rhino-project/core/i18n/browser';

const container = document.getElementById('root')!;
const root = createRoot(container);
translationsReady
  .then(() =>
    root.render(
      <StrictMode>
        <Root />
      </StrictMode>
    )
  )
  .catch((error: unknown) => {
    console.error('Unable to load translations', error);
    root.render(
      <p role="alert">Unable to load the app. Please reload this page.</p>
    );
  });
